import { LoadingSkeleton } from '../LoadingSkeleton/LoadingSkeleton';
import React from 'react';
import { AlgoliaProductHit } from '@jbhi-fi/apis/src/algolia/types/AlgoliaProductHit';
import { ProductCardSkeletonProps } from '../LoadingSkeleton/variants/ProductCard/ProductCardSkeleton';

export interface ProductFallbackProps {
  isLoading: boolean;
  product?: AlgoliaProductHit | null;
  children: React.ReactNode;
  productCardSkeletonProps?: ProductCardSkeletonProps;
}

export const ProductFallback: React.FC<ProductFallbackProps> = ({
  isLoading,
  product,
  productCardSkeletonProps = {},
  children,
}) => {
  if (isLoading) {
    return <LoadingSkeleton.ProductCardSkeleton shouldShimmer {...productCardSkeletonProps} />;
  }

  if (!product) {
    return null;
  }

  return <>{children}</>;
};
